<div class="chat-list relative">
  @if (baseService.isMobile) {
    <app-sidebar-header [trigger]="menu" [title]="'chats' | translate" [isChats]="true" />
  } @else {
    <div class="flex shrink-0 flex-col gap-2 px-[13px] pb-3 pt-2 shadow-[0_0.125rem_0.5rem_0_var(--color-default-shadow)]">
      <div class="flex h-12 items-center gap-1">
        <app-button btnType="icon" [cdkMenuTriggerFor]="menu">
          <app-icon>menu</app-icon>
        </app-button>
        <app-search class="w-100"
                    searchType="chats"
                    [autoFocus]="false"
                    (onValueChange)="onSearch($event)">
        </app-search>
        <app-button btnType="icon"
                    [attr.title]="'filters' | translate"
                    [cdkMenuTriggerFor]="filterMenu"
                    [cdkMenuPosition]="filterMenuPositions">
          <app-icon [class]="hasFilters ? 'text-blue-600' : ''" [badgeHidden]="!hasFilters">
            filter_list
          </app-icon>
        </app-button>
      </div>

      <div class="flex gap-1 rounded-xl bg-gray-100 p-1">
        @for (opt of tabOptions; track opt.value) {
          <button type="button"
                  class="flex h-9 min-w-0 flex-1 items-center justify-center gap-2 rounded-lg! px-2 text-sm font-medium transition-colors"
                  [class]="chatService.selectedChatTab === opt.value
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-500 hover:text-gray-900'"
                  (click)="setTab(opt.value)">
            <span class="truncate">{{ opt.label | translate }}</span>
            @if (opt.value === chatService.selectedChatTab && chatService.chatsInfo.total) {
              <span class="flex h-5 min-w-5 shrink-0 items-center justify-center rounded-full bg-[var(--primary-color)] px-1.5 text-xs font-semibold leading-none text-white">
                {{ chatService.chatsInfo.total > 99 ? '99+' : chatService.chatsInfo.total }}
              </span>
            }
          </button>
        }
      </div>
    </div>
  }

  @if (baseService.isMobile && isSearch) {
    <app-search class="w-100"
                searchType="chats"
                (onValueChange)="onSearch($event)"
                [clearVisibility]="true"
                (onClearChange)="toggleSearch()"
                [autoFocus]="true" />
  }

  @if (baseService.isMobile) {
    <div class="box-items crm-scroll">
      @for (item of menuItems; track $index) {
        @if (!item.hidden) {
          <div class="menu-item click-css"
               (click)="onChangeTab(item.key)"
               [ngClass]="{'active-menu': item.key === chatService.selectedTab.key }">
            @if (item.is_mat_icon) {
              <app-icon>{{ item.icon }}</app-icon>
            } @else {
              <img [src]="item.icon" alt="chat menu icon" class="menu-icon rounded-circle" />
            }
          </div>
        }
      }
    </div>
  }

  @if (chatService.isLoaderChatList.center) {
    <div class="loader">
      <app-loader></app-loader>
    </div>
  }

  @if (chatService.isLoaderChatList.up) {
    <app-loader type="indeterminate" />
  }

  @if (!chatService.isLoaderChatList.center) {
    <div (scroll)="scrollTo($event)"
         [ngClass]="{ 'hidden-scroll': baseService.isMobile }"
         class="chat-list-items-wrapper crm-scroll">
      @if (!(chatService.chatsInfo.items && chatService.chatsInfo.items.length)) {
        <div class="not-found">
          {{ 'no_dialog_found'| translate }}.
        </div>
      }
      @for (chat of chatService.chatsInfo.items; track chat.id) {
        <app-chat-list-item [chat]="chat"
                            [selected]="chatService.selectedChatId === chat.id"
                            (click)="chatService.selectedChatId !== chat.id && chatService.selectChat(chat.id)" />
      }
    </div>
  }

  @if (chatService.isLoaderChatList.down) {
    <app-loader type="indeterminate" />
  }

  @if (isShowWriteMessage) {
    <button type="button"
            class="absolute bottom-4 right-4 z-[3] flex h-12 w-12 items-center justify-center rounded-full! bg-[var(--primary-color)] text-white shadow-lg transition-colors hover:bg-[var(--primary-color)]/90"
            [attr.title]="'write_message' | translate"
            (click)="writeMessage()">
      <app-icon>add</app-icon>
    </button>
  }

  <div class="resizer" (mousedown)="onMouseDown($event)"></div>
</div>

<ng-template #menu>
  <div class="context-menu crm-scroll w-80 !max-w-[calc(100vw-1rem)]" cdkMenu>
    @for (item of chatListMenuItems; track $index) {
      @if (isMenuButtonVisible(item)) {
        <div class="context-menu-item"
             [ngClass]="{'menu-button': item.type === MENU_ITEM_TYPE.BUTTON }">
          <div (click)="item.type === MENU_ITEM_TYPE.BUTTON && item.action?.()"
               cdkMenuItem
               [cdkMenuItemDisabled]="item.type !== MENU_ITEM_TYPE.BUTTON"
               class="title-wrap clear-line">
            <app-icon class="text-black">{{ item.icon }}</app-icon>
            <span class="menu-title text-black">{{ item.title | translate }}</span>
          </div>

          @if (item.type === MENU_ITEM_TYPE.TOGGLE) {
            <mat-button-toggle-group class="d-flex justify-content-start w-100"
                                     [(ngModel)]="item.model"
                                     (change)="item.onChange?.($event)">
              @for (opt of item.toggleOptions; track $index) {
                <mat-button-toggle [value]="opt.value"
                                   cdkMenuItem>
                  {{ opt.label | translate }}
                </mat-button-toggle>
              }
            </mat-button-toggle-group>
          }

          @if (item.type === MENU_ITEM_TYPE.CHANNELS_DROPDOWN) {
            <app-dropdown [multiple]="true"
                          [blur]="false"
                          [searchable]="true"
                          [clearable]="true"
                          [isVertical]="true"
                          [isAppendToBody]="false"
                          [closeOnSelect]="false"
                          [maxViewElements]="3"
                          [hasImg]="true"
                          [items]="channels"
                          bindValue="id"
                          bindLabel="name"
                          [formControl]="formChannels"
                          (onValueChange)="updateChats()"
                          [placeholder]="'channels_not_selected' | translate" />
          }

          @if (item.type === MENU_ITEM_TYPE.TAGS_DROPDOWN) {
            <app-dropdown [multiple]="true"
                          [blur]="false"
                          [searchable]="true"
                          [clearable]="true"
                          [isAppendToBody]="false"
                          [closeOnSelect]="false"
                          [maxViewElements]="3"
                          [items]="tags"
                          bindValue="id"
                          bindLabel="name"
                          optionColorField="color"
                          [formControl]="formTags"
                          (onValueChange)="updateChats()"
                          [placeholder]="'chat_tags' | translate" />
          }

          @if (item.type === MENU_ITEM_TYPE.MANAGERS_DROPDOWN) {
            <app-dropdown [multiple]="true"
                          [blur]="false"
                          [searchable]="true"
                          [clearable]="true"
                          [isAppendToBody]="false"
                          [closeOnSelect]="false"
                          [maxViewElements]="3"
                          [isAvatar]="true"
                          [items]="managers"
                          bindValue="id"
                          bindLabel="name"
                          [formControl]="formManagers"
                          (onValueChange)="updateChats()"
                          [placeholder]="'select_manager' | translate" />
          }
        </div>
      }
    }
  </div>
</ng-template>

<ng-template #filterMenu>
  <div cdkMenu class="flex w-[22rem] max-w-[calc(100vw-1rem)] flex-col gap-3 rounded-xl border border-gray-100 bg-white p-3 shadow-lg">
    <div class="flex items-center justify-between gap-2">
      <span class="text-sm font-semibold text-gray-900">{{ 'filters' | translate }}</span>
      @if (hasFilters) {
        <button type="button"
                class="rounded-md! px-1.5 py-0.5 text-xs font-medium text-blue-600 hover:bg-blue-50"
                (click)="clearFilters()">
          {{ 'reset' | translate }}
        </button>
      }
    </div>

    <div class="flex flex-col gap-1.5">
      <span class="text-xs font-medium text-gray-500">{{ 'sort.sort' | translate }}</span>
      <div class="flex gap-1 rounded-lg bg-gray-100 p-0.5">
        @for (opt of sortOptions; track opt.value) {
          <button type="button"
                  class="flex-1 rounded-md! px-2 py-1 text-xs font-medium transition-colors"
                  [class]="chatService.selectedChatSort === opt.value
                    ? 'bg-white text-gray-900 shadow-sm'
                    : 'text-gray-600 hover:text-gray-900'"
                  (click)="setSort(opt.value)">
            {{ opt.label | translate }}
          </button>
        }
      </div>
    </div>

    @if (chatService.isConversationTypeAvailable()) {
      <div class="flex flex-col gap-1.5">
        <span class="text-xs font-medium text-gray-500">{{ 'conversation_type.title' | translate }}</span>
        <div class="flex gap-1 rounded-lg bg-gray-100 p-0.5">
          @for (opt of conversationTypeOptions; track opt.value) {
            <button type="button"
                    class="flex-1 rounded-md! px-2 py-1 text-xs font-medium transition-colors"
                    [class]="chatService.selectedConversationType === opt.value
                      ? 'bg-white text-gray-900 shadow-sm'
                      : 'text-gray-600 hover:text-gray-900'"
                    (click)="setConversationType(opt.value)">
              {{ opt.label | translate }}
            </button>
          }
        </div>
        @if (chatService.appliedConversationType !== CHAT_CONVERSATION_TYPE.ALL) {
          <app-checkbox class="-ml-2 text-xs text-gray-700"
                        [checked]="chatService.isConversationTypeExclusive"
                        (change)="setConversationExclusive($event)">
            {{ conversationExclusiveLabel | translate }}
          </app-checkbox>
        }
      </div>
    }

    <div class="-mx-1 flex flex-col border-t border-gray-100 pt-2">
      @for (group of filterGroups; track group.key) {
        <button type="button"
                cdkMenuItem
                class="flex w-full items-center gap-3 rounded-lg! px-2 py-2 text-left text-sm text-gray-700 hover:bg-gray-50"
                [cdkMenuTriggerFor]="filterSubmenu"
                [cdkMenuTriggerData]="{ group: group.key }"
                (cdkMenuClosed)="setFilterQuery(group.key, '')">
          <app-icon class="!text-[20px] !h-5 !w-5 !leading-none text-gray-500">{{ group.icon }}</app-icon>
          <span class="min-w-0 flex-1 truncate">{{ group.title | translate }}</span>
          @if (getSelectedIds(group.key).length) {
            <span class="rounded-full bg-blue-50 px-1.5 text-xs font-semibold leading-5 text-blue-600">
              {{ getSelectedIds(group.key).length }}
            </span>
          }
          <app-icon class="!text-[18px] !h-[18px] !w-[18px] !leading-none text-gray-400">chevron_right</app-icon>
        </button>
      }
    </div>
  </div>
</ng-template>

<ng-template #filterSubmenu let-group="group">
  <div cdkMenu class="flex w-64 max-w-[calc(100vw-1rem)] flex-col gap-1 rounded-xl border border-gray-100 bg-white p-2 shadow-lg">
    @if (getFilterOptions(group).length > FILTER_SEARCH_THRESHOLD) {
      <input type="text"
             class="mb-1 h-8 w-full rounded-lg border border-gray-200 px-2.5 text-sm outline-none focus:border-blue-400"
             [placeholder]="'search' | translate"
             [value]="getFilterQuery(group)"
             (input)="setFilterQuery(group, $any($event.target).value)"
             (keydown)="$event.stopPropagation()" />
    }

    <div class="flex max-h-72 flex-col overflow-y-auto crm-scroll">
      @if (getNoneOptionKey(group); as noneKey) {
        <button type="button"
                class="flex w-full items-center gap-2.5 rounded-lg! px-2 py-1.5 text-left text-sm text-gray-700 hover:bg-gray-50"
                (click)="toggleFilterOption(group, CHAT_FILTER_NONE)">
          <app-icon [class]="'!text-[20px] !h-5 !w-5 !leading-none ' + (isFilterOptionSelected(group, CHAT_FILTER_NONE) ? 'text-blue-600' : 'text-gray-300')">
            {{ isFilterOptionSelected(group, CHAT_FILTER_NONE) ? 'check_box' : 'check_box_outline_blank' }}
          </app-icon>
          <span class="flex h-[22px] w-[22px] shrink-0 items-center justify-center rounded-full bg-gray-100 text-gray-400">
            <app-icon class="!text-[16px] !h-4 !w-4 !leading-none">{{ group === 'tag' ? 'label_off' : 'person_off' }}</app-icon>
          </span>
          <span class="min-w-0 flex-1 truncate">{{ noneKey | translate }}</span>
        </button>
        <div class="mx-2 my-1 border-t border-gray-100"></div>
      }
      @for (option of getVisibleFilterOptions(group); track option.id) {
        <button type="button"
                class="flex w-full items-center gap-2.5 rounded-lg! px-2 py-1.5 text-left text-sm text-gray-700 hover:bg-gray-50"
                (click)="toggleFilterOption(group, option.id)">
          <app-icon [class]="'!text-[20px] !h-5 !w-5 !leading-none ' + (isFilterOptionSelected(group, option.id) ? 'text-blue-600' : 'text-gray-300')">
            {{ isFilterOptionSelected(group, option.id) ? 'check_box' : 'check_box_outline_blank' }}
          </app-icon>
          @switch (group) {
            @case ('channel') {
              @if (option.img_url) {
                <img [src]="option.img_url" alt="" class="h-5 w-5 shrink-0 rounded-full object-cover" />
              }
              <span class="min-w-0 flex-1 truncate">{{ option.name }}</span>
            }
            @case ('tag') {
              <app-tag class="min-w-0" [tag]="option" [maxCharacters]="24" />
            }
            @case ('manager') {
              <app-avatar [url]="option.img_url" [title]="option.name" size="22px" [isPhotoGallery]="false" />
              <span class="min-w-0 flex-1 truncate">{{ option.name }}</span>
            }
          }
        </button>
      } @empty {
        <span class="px-2 py-3 text-center text-sm text-gray-400">{{ 'nothing_found' | translate }}</span>
      }
    </div>
  </div>
</ng-template>
